import React from "react";
import Dropdown from "react";
import styled from "styled-components";
import LeftSpark from '../images/LeftSpark.svg';
import RightSpark from '../images/RightSpark.svg';
import { colors, mediaQueries, fonts } from "../shared/config";
const { bg, accents } = colors;
const { mobile } = mediaQueries;
const { titles } = fonts;

const Container = styled("div")`

  position: -webkit-sticky; /* Safari & IE */
  position: sticky;
  width: 100%;
  height: 60px;
  display: flex;
  
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px 0;
  background-color: ${accents};
  font-family: ${titles};
  font-weight: 600;
  

  ${mobile} {
    flex-direction: column;
    justify-content: none;
    height: 30px;
    padding: 0.75em 0;
  }
`;

const Title = styled("div")`
  color: white;
  text-decoration: none;
  text-align: center;
  font-size: 20px;
  text-transform: uppercase;

  display: flex;
  align-items: center;
  justify-content: center;

  ${mobile} {
    font-size: 10px;
    text-align: center;
  }
`;

// const Linked = styled("div")`
//   width: 30%;
//   display: flex;
//   justify-content: space-between;

//   ${mobile} {
//     padding-top: 0.5em;
//     flex-direction: column;
//     align-items: center;
//   }
// `;

// const Section = styled("a")`
//   color: ${bg};
//   text-decoration: none;
//   text-align: center;
//   font-size: 26px;

//   text-transform: uppercase;

//   ${mobile} {
//     font-size: 18px;
//   }
//   margin-left: 30px;
// `;

const Spark = styled.img`
  height: 35px;
  margin-right: 10px;
  margin-left: 10px;
  ${mobile} {
    height: 20px;
  }
`

export default function Nav() {
  return (
    <>
      <Container>
        <Title><Spark src={LeftSpark}/>Sundance 2022<Spark src={RightSpark}/></Title>
      </Container>
    </>
  );
}
